import { adjectives, scientists } from './WorkerNameSources';

const randomDefaultBrainName = () => {
	const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
	const scientist = scientists[Math.floor(Math.random() * scientists.length)];
	return `${adjective} ${scientist}`;
};

export default randomDefaultBrainName;
